import script from "./ProductFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFeatures.vue?vue&type=script&setup=true&lang=js"

import "./ProductFeatures.vue?vue&type=style&index=0&id=4076a018&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4076a018"]])

export default __exports__